import React, { useState } from "react"
import L10n from "lib/carrot-l10n"
import WizardWrapper from "components/views/atoms/forms/WizardWrapper"
import RequestCardHeader from "components/views/requestcard/RequestCardHeader"
import { HR, Spacer } from "components/views/atoms/Atoms"
import RequestCardWizardHeader from "components/views/requestcard/RequestCardWizardHeader"
import { Body } from "../atoms/Bodies"
// eslint-disable-next-line import/no-restricted-paths
import { MasterLayout } from "../atoms/layouts/MasterLayout"
import { BodyWithRightSidebarLayout } from "../atoms/layouts/BodyWithRightSidebarLayout"
import CarrotClient from "carrot-api"
import { useForm } from "react-hook-form"
import { useDispatch } from "react-redux"
import { fetchUserInfo } from "actions/userActions"
import { useHistory } from "react-router-dom"
import { fetchReimbursementDetails } from "../../../actions/reimbursementDetailsActions"
import EmployeeOnlySpaceContainer from "../../employee-only-containers/EmployeeOnlySpaceContainer"
import { Checkbox, FormControlLabel } from "@carrotfertility/carotene-core"
import { useToggle } from "../../../utils/Hooks"
import { getCompiler } from "../../../utils/MarkdownCompile"
/* eslint-disable import/no-restricted-paths */
import { elements } from "../DefaultMarkdown"
/* eslint-enable import/no-restricted-paths */
import { TextLink } from "../atoms/links/TextLink"
import Settings from "../../../utils/CarrotConfig"
// eslint-disable-next-line import/no-restricted-paths
import ErrorMessageMarkdown from "../login/ErrorMessageMarkdown"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()
// @ts-expect-error TS7009
const client = new CarrotClient(Settings.CARROT_BACKEND_URL)

const newElements = {
  ...elements,
  // @ts-expect-error TS7031
  p({ children }) {
    return <p>{children}</p>
  },
  // @ts-expect-error TS7031
  a({ href, title, children }) {
    return (
      <TextLink to={href} target="_blank" title={title}>
        {children}
      </TextLink>
    )
  }
}

const DefaultVerifyPhoneNumberState = {
  formNotComplete: false,
  isInError: false,
  sending: false,
  isResendLinkVisible: false
}

// @ts-expect-error TS7006
const StripeUserAgreement = (props) => {
  const { handleSubmit, clearErrors } = useForm()
  const [state, setState] = useState(DefaultVerifyPhoneNumberState)
  const history = useHistory()
  const dispatch = useDispatch()

  const onSubmit = handleSubmit(async () => {
    clearErrors()
    try {
      setState({
        ...state,
        formNotComplete: false,
        isInError: false,
        sending: true
      })

      await client.requestCard()

      history.push("/request-card/success")
      await dispatch(fetchReimbursementDetails())
      await dispatch(fetchUserInfo())
    } catch (e) {
      setState({ ...state, isInError: true, sending: false })
    }
  })

  const backRoute = props.requestCardPath + "/phone-verification"
  const [checked, toggleChecked] = useToggle(false)
  const md = getCompiler(newElements)
  return (
    <MasterLayout header={<RequestCardHeader backRoute={backRoute} />}>
      <EmployeeOnlySpaceContainer>
        <BodyWithRightSidebarLayout>
          <RequestCardWizardHeader step={2}>{l`carrotCard.request.reviewTerms`}</RequestCardWizardHeader>
          <WizardWrapper
            back
            done
            backRoute={backRoute}
            doneText={l`next`}
            onDone={onSubmit}
            nextDisabled={!checked}
            sending={state.sending}
          >
            {state.isInError ? (
              <ErrorMessageMarkdown align="tl" source={l`carrotCard.request.error`} />
            ) : (
              <Body color="black-80">{l`carrotCard.request.stripeUserAuthorization`}</Body>
            )}
            <Spacer height={1.5} />
            <FormControlLabel
              control={
                <Checkbox
                  checked={checked}
                  onChange={toggleChecked}
                  id="stripe-user-agreement-checkbox"
                  name={"stripeUserAgreementCheckbox"}
                />
              }
              label={md(l`carrotCard.request.stripeUserAuthorizationCheckbox`)}
            />
            <Spacer height={1.5} />
            <Spacer height={1} />
          </WizardWrapper>
          <Spacer height={1.5} />
          <HR color="black-20" />
        </BodyWithRightSidebarLayout>
      </EmployeeOnlySpaceContainer>
    </MasterLayout>
  )
}

export { StripeUserAgreement }
